import React, { useEffect, useState } from "react";
import TripCard from "./TripCard";
import "../css/TripsList.css";
import { useNavigate } from "react-router-dom";

const TripsList = ({
  title,
  trips,
  footerName,
  isClickable,
  initialVisibleCount = null,
  loadMoreCount = 10,
  eagerImageCount = 2,
  eagerLoadAllImages = false,
}) => {
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(initialVisibleCount);

  useEffect(() => {
    setVisibleCount(initialVisibleCount);
  }, [initialVisibleCount, trips]);

  const handleCardClick = (trip) => {
    if (!isClickable) return;

    if (trip.externalLink) {
      window.location.href = trip.externalLink;
    } else {
      navigate(`/${trip.guid}`);
    }
  };

  const sectionType = title.toLowerCase().includes("nadchodz") ? "upcoming" : title.toLowerCase().includes("planowan") ? "planned" : "finished";
  const sectionDescription = { upcoming: "Najbliższe wyjazdy i wspólne przygody.", planned: "Więcej przygód już wkrótce. Stay tuned!", finished: "Nasze ostatnie przygody." }[sectionType];

  const filteredTrips = trips;

  const visibleTrips = visibleCount == null
    ? filteredTrips
    : filteredTrips.slice(0, visibleCount);

  const hasMoreTrips = visibleCount != null && visibleTrips.length < filteredTrips.length;
  const nextBatchSize = hasMoreTrips
    ? Math.min(loadMoreCount, filteredTrips.length - visibleTrips.length)
    : 0;

  const handleLoadMore = () => {
    setVisibleCount((currentCount) => (currentCount ?? 0) + loadMoreCount);
  };

  return (
    <section className={`trips-list trips-list--${sectionType}`}>
      <div className="trips-list-header">
        <div className="trips-list-heading"><h2 className="trips-list-title">{sectionType === "upcoming" ? "Nadchodzące wycieczki" : sectionType === "planned" ? "Planowane wycieczki" : "Zakończone wycieczki"}</h2><p className="trips-list-subtitle">{sectionDescription}</p></div>

      </div>

      <div className="trips-list-grid">
        {visibleTrips.map((trip, index) => (
          <div
            key={trip.guid}
            onClick={() => handleCardClick(trip)}
            className={`trip-card-wrapper ${
              isClickable ? "clickable" : "disabled"
            }`}
          >
            <TripCard
              title={trip.name}
              startDate={trip.startDate}
              endDate={trip.endDate}
              description={trip.description}
              photo={trip.photoThumbnailLink}
              photoSource={trip.photoSource}
              footerName={footerName}
              isClickable={isClickable}
              hasOpenRegistration={trip.hasOpenRegistration}
              eagerLoadImage={eagerLoadAllImages || index < eagerImageCount}
            />
          </div>
        ))}
      </div>

      {hasMoreTrips && (
        <div className="trips-list-load-more-wrapper">
          <button
            type="button"
            className="trips-list-load-more"
            onClick={handleLoadMore}
          >
            Pokaż kolejne {nextBatchSize}
          </button>
        </div>
      )}
    </section>
  );
};

export default TripsList;